






























import { TicketParams } from '@/store/interfaces/tickets';
import { ticketableType } from '@/util/transformString/translationsDecorator';
import support from './../previews/support.vue';
import PaymentRefund from './../previews/paymentRefund.vue';
import PaymentRequest from './../previews/paymentRequest.vue';
import withdrawalsRefund from './../previews/withdrawalsRefund.vue';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'DetailTicketModal',
  components: {
    support,
    PaymentRefund,
    PaymentRequest,
    withdrawalsRefund,
  },
  props: {
    ticket: {
      type: Object as PropType<TicketParams>,
      required: true,
    },
    viewModal: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean): void {
        this.$emit('update:viewModal', value);
      },
    },
  },
  methods: {
    ticketableTypeTranslate(ticket: string): string {
      return ticketableType(ticket);
    },
    close(): void {
      this.$emit('update:viewModal', false);
    },
  },
});
